import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../contexts";
import { toast } from "react-toastify";
import { toastOptions, constants } from "../../assets/constants";
import { Checkbox } from "@mui/material";
import { CheckIcon, PencilIcon } from "@phosphor-icons/react";
import { CustomPageHeader } from "../../ui";
import "../../assets/css/pages/role-add.css";

const RoleAdd = () => {
    const [buttonLoading, setButtonLoading] = useState(false);
    const { token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [role, setRole] = useState({
        name: "",
        modules: [],
    });

    const handleCreate = () => {
        setButtonLoading(true);
        axios
            .post(process.env.REACT_APP_UPA_API_HOST + "users/roles", role, {
                headers: { Authorization: "Bearer " + token },
            })
            .then((response) => {
                console.log(response);
                setButtonLoading(false);
                window.dispatchEvent(new CustomEvent("rolesDataUpdated"));
                toast.success("Le rôle a bien été ajouté", toastOptions);
                navigate(-1);
            })
            .catch((error) => {
                toast.error(error.response.data.message, toastOptions);
                setButtonLoading(false);
            });
    };

    const handleSelectModule = (event, module) => {
        let selectedModules = [...role.modules];
        if (event.target.checked) {
            selectedModules.push({ value: module.value, submodules: [] });
        } else {
            selectedModules = selectedModules.filter((selectedModule) => selectedModule.value !== module.value);
        }
        setRole({ ...role, modules: selectedModules });
    };

    const handleSelectSubmodule = (event, module, submodule) => {
        let selectedModules = [...role.modules];
        if (event.target.checked) {
            selectedModules.find((mod) => mod.value === module.value).submodules.push(submodule.value);
        } else {
            const foundSubmodules = selectedModules.find((mod) => mod.value === module.value).submodules;
            foundSubmodules.splice(foundSubmodules.indexOf(submodule.value));
        }
        setRole({ ...role, modules: selectedModules });
    };

    React.useEffect(() => console.log(role), [role]);

    return (
        <div className="c-app__view">
            <CustomPageHeader
                title="Créer un rôle"
                titleIcon={{ icon: PencilIcon }}
                buttons={[
                    {
                        label: "Annuler",
                        onClick: () => navigate(-1),
                        variant: "cancel",
                    },
                    {
                        label: "Créer le rôle",
                        onClick: handleCreate,
                        variant: "success",
                        icon: CheckIcon,
                        disabled: buttonLoading,
                        loading: buttonLoading,
                    },
                ]}
            />
            <div className="c-modal-content">
                <div className="custom__modal-group">
                    <label className="name">Nom</label>
                    <input
                        value={role.name}
                        className="classic-input"
                        placeholder="Entrez un nom"
                        onChange={(e) => {
                            setRole((role) => {
                                return { ...role, name: e.target.value };
                            });
                        }}
                    />
                </div>
                <div className="role-add__modules">
                    {constants.modules.map((module, index) => (
                        <div key={index} className="role-add__module">
                            <div className="role-add__module-header">
                                <Checkbox className="role-add__checkbox" onChange={(e) => handleSelectModule(e, module)} checked={role.modules.some((mod) => mod.value === module.value)} />
                                <span className="role-add__module-title">{module.label}</span>
                            </div>
                            <div className="role-add__submodules">
                                {module.submodules.map((submodule, subIndex) => (
                                    <div key={subIndex} className="role-add__submodule">
                                        <Checkbox
                                            className="role-add__checkbox"
                                            checked={role.modules.some((mod) => mod.value === module.value && mod.submodules.some((sub) => sub === submodule.value))}
                                            disabled={!role.modules.some((selectedModule) => selectedModule.value === module.value)}
                                            onChange={(e) => handleSelectSubmodule(e, module, submodule)}
                                        />
                                        <span className="role-add__submodule-label">{submodule.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RoleAdd;
